import React, { useState, useEffect, useContext } from 'react'
import ReactDOM from 'react-dom'
import ReceiptHeader from './ReceiptHeader'
import ReceiptInner from './ReceiptInner'
import ReceiptFooter from './ReceiptFooter'
import { appContext } from '../../../App'
import { dateYMD } from '../../utilities/utilities'
import { getReceiptsList, saveReceipt, deleteReceipt } from '../ReceiptFunctions'

export const receiptControllerContext = React.createContext()

function useReceiptController(props) {
  const app = useContext(appContext)
  const { receipt_for } = props
  const [paymentsUpdated, setPaymentsUpdated] = useState(false)
  let paidBy, amountToPay

  // Edit receipt mode
  if (props.receipt) props.receipt.receipt_date = dateYMD(new Date(props.receipt.receipt_date))

  // Or else it's a new receipt
  //const paidBy = (!props.receipt)
  paidBy = (!props.receipt)
  ? (receipt_for.item_name === 'Invoice')
    ? receipt_for.item.customer_details.sold_to
    : receipt_for.item.customer_details.account_name
  : null

  //const amountToPay = (!props.receipt)
  amountToPay = (!props.receipt)
  ? (receipt_for.item_name === 'Invoice')
    ? {
        total_amount: receipt_for.item.invoice_summary.total_sales, // VAT + NONE-VAT Sales
        total_vated_amout: receipt_for.item.invoice_summary.vat_total_sales,
        total_vat_amount: receipt_for.item.invoice_summary.vat_amount,
        total_none_vat_amount: receipt_for.item.invoice_summary.none_vat_total_sales,
        vat_percent: receipt_for.item.vat
      }
    : {
        total_amount: receipt_for.item.credit_total_balance ,
        total_vated_amout: 0,
        total_vat_amount: 0,
        total_none_vat_amount: 0,
        vat_percent: 0
      }
  : null

  const newReceipt = (!props.receipt)
  ? {
    receipt_date: dateYMD(new Date(app.getClientDateTime())),
    paid_by: paidBy,
    amount_to_pay: amountToPay,
    payments: [{ name: 'total_amount_paid', total_amount_paid: 0.00 }],
    discounts: {
      items: [],
      discount_total: { total_percent_discount: 0.00, total_discount_amount: 0.00 }
    },
    receipt_for
  }
  : null

  const [receipt, setReceipt] = useState((props.receipt) ? props.receipt : newReceipt)
  const [receiptsList, setReceiptsList] = useState(null)

  const computeTotalAmountPaid = () => {
    const totalAmountPaidIndex = receipt.payments.findIndex(item => item.name === 'total_amount_paid')
    let total_amount_paid = 0
    for (let payment of receipt.payments) {
      switch(payment.name) {
        case 'total_amount_paid':
        break
        default:
          total_amount_paid += payment.total
      }
    }

    receipt.payments[totalAmountPaidIndex] = {
      name: 'total_amount_paid',
      total_amount_paid
    }
  }

  const addPayments = (payment) => {
    const paymentIndex = receipt.payments.findIndex(item => item.name === payment.name)
    if (paymentIndex >= 0)
      receipt.payments[paymentIndex] = payment
    else
      setReceipt({...receipt, payments: [...receipt.payments, payment]})

    setPaymentsUpdated(true)
  }

  const deletePayment = (payment_name) => {
    const filteredPayments = receipt.payments
    const payments = filteredPayments.filter(payment => payment.name !== payment_name)
    setReceipt({ ...receipt, payments })
    setPaymentsUpdated(true)
  }

  useEffect(() => {
    const init = async () => {
      const receipts_list = await getReceiptsList(app)
      setReceiptsList(receipts_list)
    }
    init()
    ReactDOM.unmountComponentAtNode(document.getElementById('loading-indicator-container'))
    /* Hack to avoid the eslint warning */
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    // Usually use to rerender components only
    if (paymentsUpdated) {
      computeTotalAmountPaid()
      setPaymentsUpdated(false)
    }
    /* Hack to avoid the eslint warning */
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [paymentsUpdated])

  return ({
    receipt: [receipt, setReceipt],
    receiptsList: [receiptsList, setReceiptsList],
    addPayments,
    deletePayment,
    saveReceipt,
    deleteReceipt,
    receipt_for
  })
}

function ReceiptController(props) {
  const receiptController = useReceiptController(props)
  return (
    <React.Fragment>
      <receiptControllerContext.Provider value={receiptController}>
        <ReceiptHeader />
        <ReceiptInner />
        <ReceiptFooter />
      </receiptControllerContext.Provider>
    </React.Fragment>
  )
}

export default React.memo(ReceiptController)